import React, { useState } from "react"

import PropTypes from "prop-types"

import * as styles from "./accordion.module.scss"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"
import Icon from "../../atoms/icon"

const Accordion = ({ data }) => {
  const [openItem, setOpenItem] = useState(new Set())

  return (
    <div>
      {data.map((item, index) => (
        <div key={item.title} className={styles.item}>
          <button
            type="button"
            className={`${styles.header} ${openItem === index ? styles.header__open : ""}`}
            onClick={() => setOpenItem(index)}
            aria-expanded={openItem === index}
            aria-controls={`accordion-${index}`}
          >
            <Heading level={4} semantic={false} className={styles.title}>
              {item.title}
            </Heading>
            <div
              className={`${styles.icon} ${openItem === index ? styles.icon__rotated : ""}`}
            >
              <Icon icon="expand_more" />
            </div>
          </button>
          <div
            id={`accordion-${index}`}
            className={`${styles.content} ${openItem === index ? styles.content__open : ""}`}
            aria-hidden={!(openItem === index)}
          >
            <div className={styles.contentInner}>
              <CopyContainer content={item._rawContent} />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Accordion

Accordion.propTypes = {
  data: PropTypes.object.isRequired,
}
